export default "__VITE_PUBLIC_ASSET__6cbecd30__"